export const enumCreditableShareEntreprise = {
    CVFICHEFORMATION: 1,
    CVPAGEPROFIL: 2,
    CVPAGECANDIDAT: 3,
    PORTFOLIOFICHEFORMATION: 4,
    PORTFOLIOPAGEPROFIL: 5,
    PORTFOLIOPAGECANDIDAT: 6,
    TELEPHONE: 7,
    EMAIL: 8,
}